export default __webpack_public_path__ + "2c384be08a62ab9022ecc450216f0e92.png";